import { useEffect } from 'react';
import { useLocation } from 'react-router-dom';

import type { ServiceProfile } from '@/profile/type';

// NOTE: jsonのプロファイルを利用する。App.tsxにてstore初期化前に呼び出されているため
export const usePageTracking = (jsonServiceProfile: ServiceProfile) => {
  const location = useLocation();

  useEffect(() => {
    if (jsonServiceProfile == undefined) return;

    if (
      typeof jsonServiceProfile.gaTrackingId !== 'undefined' &&
      jsonServiceProfile.gaTrackingId !== ''
    ) {
      import('react-ga4').then((module) => {
        module.default.initialize(jsonServiceProfile?.gaTrackingId ?? '');
      });
    } else {
      console.debug('GAのトラッキングIDがありません');
    }
  }, [location, jsonServiceProfile]);
};
